import "./styles/fonts.css";
import {CssBaseline, StyledEngineProvider} from "@mui/material";
import {DialogProvider} from "muibox";
import {SnackbarProvider} from "notistack";
import React from "react";
import ReactDOM from "react-dom";
import {ReactQueryDevtools} from "react-query/devtools";
import App from "./app/App";
import {LoadingProvider} from "./components/loading/LoadingProvider";
import PostMessage from "./components/post-message/PostMessage";
import CustomQueryClientProvider from "./CustomQueryClientProvider";
import {NOME_APP, AMBIENTE} from "./shared/env";
import {
    nomeAplicacaoNeutro,
    obterAmbienteAplicacao
} from "./shared/modoAplicacao";
import {initKeycloak} from "./shared/keycloak";
import AppearanceProvider from "./shared/AppearanceProvider";

function renderApp() {
    ReactDOM.render(
        <StyledEngineProvider injectFirst>
            <AppearanceProvider>
                <DialogProvider>
                    <SnackbarProvider maxSnack={1}>
                        <LoadingProvider>
                            <CustomQueryClientProvider>
                                <CssBaseline />
                                <PostMessage>
                                    <App />
                                </PostMessage>
                                <ReactQueryDevtools initialIsOpen={false} />
                            </CustomQueryClientProvider>
                        </LoadingProvider>
                    </SnackbarProvider>
                </DialogProvider>
            </AppearanceProvider>
        </StyledEngineProvider>,
        document.getElementById("root")
    );
}

// A guarda de acesso exibe a verificação da sessão enquanto o provedor responde.
renderApp();
initKeycloak();

document.title = `${nomeAplicacaoNeutro(NOME_APP)} · ${
    obterAmbienteAplicacao(AMBIENTE).rotulo
}`;
